<template>
    <div class="pdfpage portrait">
        <h3 class="pageTitle" style="opacity: 0.0">{{divname}}2020年度部门决算公开</h3>
    </div>
    <div class="pdfpage portrait">
        <p v-for="(e,index) in $store.state.errors" :key="index" class="error">{{e.message}}</p>
        <span class="pageTitle">
            {{divname}}<br />2020年度部门决算公开
            <span v-if="port=='2617'" style="color:red"><br />（内部预览版）</span>
        </span>
    </div>
    <div class="pdfpage portrait">
        <h3>目&nbsp;&nbsp;录</h3>
        <h4>第一部分&nbsp;部门概况</h4>
        <p>一、主要职能</p>
        <p>二、部门机构设置及决算单位构成情况</p>
        <p>三、2020年度主要工作完成情况</p>
        <h4>第二部分&nbsp;2020年度部门决算表</h4>
        <p v-for="(item,index) in tableTitle" :key="index">
            {{intToChinese(index+1)}}、{{item.title}}
        </p>
        <h4>第三部分&nbsp;2020年度部门决算情况说明</h4>
        <h4>第四部分&nbsp;名词解释</h4>

    </div>
    <div class="pdfpage portrait pdfqksm">
        <h3>第一部分&nbsp;&nbsp;部门概况</h3>
        <deptSurvey :qksmData="qksm" v-if="isData"></deptSurvey>
    </div>
    <div v-for="(item,index) in subjectCofig" :key="index" :class="item.transverse ? 'table' : 'pdfpage portrait'" v-if="isData">
        <h3 v-if="index==0">第二部分&nbsp;&nbsp;{{divname}}2020年度部门决算表</h3>
        <tableindex :pdfmoreDetails="moreDetails" :pdfthreeLines="threeLines" :pdfsubjectCofig="subjectCofig" :pdfdataJson="dataJson" :tablenum="index"></tableindex>
    </div>
    <div class="pdfpage portrait pdfqksm">
        <h3>第三部分&nbsp;&nbsp;2020年度决算情况说明</h3>
        <qksm1 :T1="exprList['T1']" v-if="isData"></qksm1>
        <qksm2 :T2="exprList['T2']" v-if="isData"></qksm2>
        <div id="myChart2" class="echart" v-if="$store.state.divData.divname != '徐州市鼓楼区农机管理服务站'"></div>
        <qksm3 :T3="exprList['T3']" v-if="isData"></qksm3>
        <div id="myChart3" class="echart" v-if="$store.state.divData.divname != '徐州市鼓楼区农机管理服务站'"></div>
        <qksm4 :T4="exprList['T4']" v-if="isData"></qksm4>
        <qksm5 :T5="exprList['T5']" :T3="exprList['T3']" v-if="isData"></qksm5>
        <qksm6 :T6="exprList['T6']" v-if="isData"></qksm6>
        <qksm7 :T7="exprList['T7']" v-if="isData"></qksm7>
        <qksm8 :T8="exprList['T8']" v-if="isData"></qksm8>
        <qksm9 :T9="exprList['T9']" v-if="isData"></qksm9>
        <qksm10 :T10="exprList['T10']" v-if="isData"></qksm10>
        <qksm11 :T11="exprList['T11']" v-if="isData"></qksm11>
        <qksm12 :T12="exprList['T12']" v-if="isData"></qksm12>
        <qksm13 :T13="exprList['T13']" :T9="exprList['T9']" v-if="isData"></qksm13>
        <qksm14 :T1="exprList['T1']" v-if="isData"></qksm14>
    </div>
    <div class="pdfpage portrait mcjs">
        <h3>第四部分&nbsp;&nbsp;名词解释</h3>
        <mcjs :qksmData="qksm" :tableData="tables" :bdata="bdata" v-if="isData"></mcjs>
        <div id="isData">{{isFinish}}</div>
    </div>
</template>
<script>
    import $ from "jquery";
    import deptSurvey from "./deptSurvey.vue";
    import tableindex from "@/components/20js/table/index.vue";
    import qksm1 from "@/components/20js/qksm/qksm1.vue";
    import qksm2 from "@/components/20js/qksm/qksm2.vue";
    import qksm3 from "@/components/20js/qksm/qksm3.vue";
    import qksm4 from "@/components/20js/qksm/qksm4.vue";
    import qksm5 from "@/components/20js/qksm/qksm5.vue";
    import qksm6 from "@/components/20js/qksm/qksm6.vue";
    import qksm7 from "@/components/20js/qksm/qksm7.vue";
    import qksm8 from "@/components/20js/qksm/qksm8.vue";
    import qksm9 from "@/components/20js/qksm/qksm9.vue";
    import qksm10 from "@/components/20js/qksm/qksm10.vue";
    import qksm11 from "@/components/20js/qksm/qksm11.vue";
    import qksm12 from "@/components/20js/qksm/qksm12.vue";
    import qksm13 from "@/components/20js/qksm/qksm13.vue";
    import qksm14 from "@/components/20js/qksm/qksm14.vue";
    import mcjs from "./mcjs.vue";
    import { getDivList, songshen } from "@/api/index.js";
    import { getZoneTableProfile, getBdata } from "@/api/zone.js";
    export default {
        name: "pdfHtml",
        components: {
            deptSurvey,
            tableindex,
            qksm1,
            qksm2,
            qksm3,
            qksm4,
            qksm5,
            qksm6,
            qksm7,
            qksm8,
            qksm9,
            qksm10,
            qksm11,
            qksm12,
            qksm13,
            qksm14,
            mcjs,
        },
        data() {
            return {
                divname: "",
                tableTitle: [],
                qksm: {},
                exprList: {},
                tables: [],
                isData: false,
                isPdf: true,
                //2020年数据
                moreDetails: [],
                dataJson: "",
                subjectCofig: "",
                threeLines: "",
                bdata: {},
                clearTimeSet: null,
                dialogVisible: false,
                isFinish: false,
                port: window.location.port
            };
        },
        async created() {
            await this.getDivData();
            this.format();//格式
            this.tableNum();//表格
            this.$nextTick(function () {
                if (eval(this.$route.query.isUpload) == true) {
                    this.upload();
                }
            });
        },
        updated() {
            this.$nextTick(function () {
                if (this.isData && document.getElementById("mcjs")) {
                    if (this.$store.state.divData.divname != "徐州市鼓楼区农机管理服务站") {
                        this.isChart();
                    }
                    this.isFinish = true
                }
            });
        },
        methods: {
            async getDivData() {
                let res = await getDivList({ id: this.$route.query.divid });
                if (res.status == 0) {
                    this.$store.commit('changeDivData', res)
                    this.moreDetails = res;
                    this.divname = res.divname;
                    this.qksm = res.qksm;
                    this.tables = res.tables;
                    let resBdata = await getBdata();
                    if (resBdata.status == 0) {
                        this.bdata = resBdata.bdata;
                        resBdata.bdata.forEach((e) => {
                            this.exprList[e.name] = this.preview(e.expr).result;
                        });
                        //配置
                        let resProfile = await getZoneTableProfile();
                        if (resProfile.status == 0) {
                            let yop = "var bodyshow=true;"
                            let hop = eval(yop + resProfile.profile)
                            this.dataJson = hop.dataJson;
                            this.subjectCofig = hop.subjectCofig;
                            this.threeLines = hop.threeLines;
                            this.$store.commit("storageHop", hop);
                            this.tableTitle = hop.threeLines;
                            this.tableTitle.forEach((ele) => {
                                ele.title = ele.title.slice(ele.title.indexOf(".") + 1, ele.title.length);
                            });
                            this.isData = true;
                        }
                    }
                }
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
            isChart() {
                this.charts(
                    document.getElementById("myChart2"),
                    "收入决算图",
                    this.exprList["T2"].项目
                        .filter((e) => e.value > 0)
                        .map((e) => {
                            return {
                                name: e.name,
                                value: this.num(e.value),
                            };
                        })
                );
                this.charts(
                    document.getElementById("myChart3"),
                    "支出决算图",
                    this.exprList["T3"].项目
                        .filter((e) => e.value > 0)
                        .map((e) => {
                            return {
                                name: e.name,
                                value: this.num(e.value),
                            };
                        })
                );
            },
            async upload() {
                if (this.$store.state.errors.length > 0) {
                    var str = ""
                    var i=1
                    for (let a of this.$store.state.errors) {
                        str += "<p>"+(i++)+'、'+a.message + "</p>"
                    }
                    this.$alert(str, '请检查', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        callback: action => {
                            this.$router.push({
                                name: "部门概况",
                                query: { divid: this.$route.query.divid, sort: "one" },
                            });
                        }
                    });
                } else {
                    this.$alert('数据确认无误，请点击确定上传。', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: async action => {
                            let res = await songshen({ id: this.$route.query.divid });
                            if (res.status == 0) {
                                this.$message.success("上传成功");
                            }
                            this.$router.push({
                                name: "部门概况",
                                query: { divid: this.$route.query.divid, sort: "one" },
                            });                        }
                    });
                }
            },   
            format() {
                $("div.deptCon").each(function () {
                    let val = $(this).html().trim();
                    var f = "";
                    if (val) {
                        /*if (val.substring(val.length - 1, val.length) != "。") {
                            val = val + "。";
                        }*/
                        f = "<p  style='text-indent:2em !important'>" + val;
                        if (f) {
                            f = f.replace(/(\r|\n)\s{4}/g, '</p><p style="text-indent:2em !important">').replace(/[\r\n]/g, "</p><p>"); // 针对（换行+2个空格）
                            $(this).html(f);
                        }
                        f += "</p>";
                    } else {
                        f = "<p>未填</p>";
                    }
                    $(this).html(f);
                });
                $(".hide_pdf").each(function () {
                    $(this).remove();
                });
                $(".nogap").each(function () {
                    let html = $(this).html();
                    html = html
                        .replace(/[ \t]+?(?=\s)/g, "")
                        .replace(/(?<=\n)[ \t]*/g, "")
                        .replace(/\n/g, "")
                        .replace(/\s*/g, "");
                    $(this).replaceWith(html);
                });
                var nameLength = this.divname.length
                if (nameLength > 22) {
                    $(".pageTitle").css("font-size", "23px");
                }
                else if (nameLength == 22) {
                    $(".pageTitle").css("font-size", "24px");
                }
                else if (nameLength > 16 && nameLength < 22) {
                    $(".pageTitle").css("font-size", "26px");
                }
                else if (nameLength > 11 && nameLength < 17) {
                    $(".pageTitle").css("font-size", "32px");
                }
                else {
                    $(".pageTitle").css("font-size", "38px");
                }

            },
            tableNum() {
                const that = this;
                if (document.getElementsByTagName("table").length < 12) {
                    that.clearTimeSet = setInterval(() => {
                        that.tableNum();
                    }, 1000);
                } else {
                    this.mentTable();
                    clearInterval(that.clearTimeSet);
                }
            },
            mentTable() {
                $(".table table").each(function () {
                    /**江苏跨页不加表头 */
                    var sum = 0;
                    var tr = "";
                    var remarks = $(this).siblings(".tableTips").prop("outerHTML");
                    $(this).find("tr").each(function () {
                        tr += "<tr>" + $(this).html() + "</tr>";
                        sum = sum + $(this).outerHeight(true);
                        if (Number(sum) > 935) {
                            tr += '</table></div><div class="pdfpage landscape"><table>';
                            sum = 0;
                        }
                    });
                    if (tr.substring(tr.length - 52) == '</table></div><div class="pdfpage landscape"><table>') {
                        tr = tr.substring(0, tr.length - 52);
                    }
                    var html = '<div class="pdfpage landscape"><table>' + tr + "</table>" + remarks + "</div>";
                    $(this).parent().replaceWith(html);
                });
            },
        },
        //离开之前清除缓存
    };
</script>
<style>
    .left16 {
        padding-left: 1.6rem !important;
    }

    @page {
        size: a4;
        margin: 2cm -6cm 2cm 3cm;
    }

    @page rotated {
        size: landscape;
    }
    /*横置*/
    .landscape {
        page: rotated;
        width: 100%;
        height: 25cm;
    }
    /*竖表*/
    .portrait {
        width: calc(100% - 9cm) !important;
    }

    .pdfpage .hide_pdf {
        display: none;
    }

    .pdfpage {
        page-break-after: always;
    }

        .pdfpage .pageTitle {
            margin-top: 25vh;
            font-family: FangSong !important;
            font-weight: bold;
            /* font-size: 40px !important; */
            line-height: 2em;
            text-align: center;
            width: 100%;
            display: block;
        }

        .pdfpage h3 {
            font-size: 21px !important;
            text-align: center;
            width: 100%;
            margin-top: 0 !important
        }

        .pdfpage .echart {
            page-break-inside: avoid;
            margin: 0 auto;
            height: 400px;
            width: 14cm !important;
            border: 1px red solid;
            padding: 10px;
        }

        .pdfpage p,
        .pdfpage h4,
        .pdfpage b {
            font-size: 21px !important;
            font-family: FangSong !important;
            line-height: 2em !important;
        }

        .pdfpage h4,
        .pdfpage b {
            font-family: SimHei !important;
        }

        .pdfpage p {
            text-align: justify;
        }

    .pdfqksm {
        height: auto !important;
    }

        .pdfqksm p,
        .pdfqksm h4 {
            text-indent: 2em;
        }

    .pdfpage table {
        margin: 0 auto;
        width: 100%;
        /*border: 1px solid #808080;*/
        border-spacing: 0;
        border-collapse: collapse;
        font-size: 18px;
        font-family: FangSong;
    }

        .pdfpage table thead {
            display: table-row-group;
        }

        .pdfpage table tr {
            /*page-break-before: always;
            page-break-after: always;
            page-break-inside: avoid;*/
        }

            .pdfpage table tr th,
            .pdfpage table tr td {
                border: 1px solid #808080;
                color: #000;
            }

            .pdfpage table tr th {
                height: 18px !important;
                line-height: 16px !important;
                font-size: 13px !important;
                font-weight: bold;
            }

            .pdfpage table tr td {
                font-size: 13px !important;
                line-height: 16px !important;
                height: 18px !important;
            }

            .pdfpage table tr .showright {
                font-size: 12px !important;
            }

            .pdfpage table tr .headerTitle {
                font-size: 18px !important;
            }

    .pdfpage .tableTips p {
        font-size: 13px !important;
        line-height: 14px !important;
    }

        .pdfpage .tableTips p .left16 {
            padding-left: 1.9rem !important;
        }

    #isData {
        color: #fff;
        opacity: 0;
    }

    .error {
        color: red;
    }
</style>
